import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {
  dismissSolBootSplash,
  SOL_BOOTING_HTML_CLASS,
} from './dismissSolBootSplash';

export const PWA_BOOT_SPLASH_READY_HOLD_MS = 300;

export function PwaBootSplash() {
  const router = useRouter();

  useEffect(() => {
    if (!document.documentElement.classList.contains(SOL_BOOTING_HTML_CLASS)) {
      dismissSolBootSplash();
      return;
    }

    if (!router.isReady) return;

    const readyTimer = window.setTimeout(
      dismissSolBootSplash,
      PWA_BOOT_SPLASH_READY_HOLD_MS
    );

    return () => window.clearTimeout(readyTimer);
  }, [router.isReady]);

  return null;
}
